import React from "react";
import { Controller } from "react-hook-form";
import Input from "../input";
import Textarea from "../textarea";
import FIlterSelect from "../filter-select";

interface InformationDetailsProps {
  control: any;
  errors: any;
}

export const DeliveryInformation: React.FC<InformationDetailsProps> = ({
  control,
}) => {
  return (
    <div className="items-center gap-4 mt-2">
      <Controller
        name="deliveryMethod"
        control={control}
        rules={{
          required: "Delivery is required",
        }}
        render={({ field, fieldState }) => (
          <FIlterSelect
            name="deliveryMethod"
            value={field.value}
            className="w-full mb-2"
            options={[
              { value: "pick-up", label: "Pick Up" },
              { value: "dispatch", label: "Dispatch" },
            ]}
            label="Delivery method"
            error={fieldState?.error?.message}
            onChange={field.onChange}
          />
        )}
      />

      <Controller
        name="deliveryFee"
        control={control}
        rules={{
          required: "Delivery Fee is required",
        }}
        render={({ field, fieldState }) => (
          <Input
            value={field.value}
            className="w-full"
            placeholder="Enter delivery fee"
            error={fieldState?.error?.message}
            onChange={field.onChange}
            autoComplete="off"
            label="Delivery Fee"
          />
        )}
      />

      <Controller
        name="deliveryNote"
        control={control}
        rules={{
          required: "Note is required",
        }}
        render={({ field, fieldState }) => (
          <Textarea
            value={field.value}
            className="w-full"
            placeholder="Enter your main text here..."
            error={fieldState?.error?.message}
            onChange={field.onChange}
            label="Delivery Notes"
          />
        )}
      />
    </div>
  );
};
